import { TETHER_SYMBOL } from "@/constants";
import { SubscriptionCurrency } from "@prisma/client";
import { validate } from "multicoin-address-validator";
import { z } from "zod";

export const addressSchema = z
  .object({
    address: z.string().min(1),
    currency: z.nativeEnum(SubscriptionCurrency),
  })
  .refine(
    (data) => {
      let currency = data.currency.split("_")[0];
      if (currency.startsWith(TETHER_SYMBOL)) {
        currency = TETHER_SYMBOL.toLowerCase();
      } else {
        currency = currency.toLowerCase();
      }

      const isValid = validate(data.address, currency);

      return isValid;
    },
    {
      message: "Invalid address",
      path: ["address"],
    },
  );

export type Address = z.infer<typeof addressSchema>;
